import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import axios from "axios";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL; // For static files (signatures, attachments)

// Format date to readable string
export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

// Check if certificate is expired
export function isExpired(expiryDate) {
  if (!expiryDate) return false;
  return new Date(expiryDate) < new Date();
}

// Check if certificate is expiring soon (within 30 days)
export function isExpiringSoon(expiryDate) {
  if (!expiryDate) return false;
  const thirtyDaysFromNow = new Date();
  thirtyDaysFromNow.setDate(thirtyDaysFromNow.getDate() + 30);
  const expiry = new Date(expiryDate);
  return expiry > new Date() && expiry <= thirtyDaysFromNow;
}

// Get certificate status
export function getCertificateStatus(expiryDate) {
  if (isExpired(expiryDate)) return 'expired';
  if (isExpiringSoon(expiryDate)) return 'expiring';
  return 'active';
}

// User roles
export const UserRoles = {
  ADMIN: 'admin',
  TRAINING_ADMIN: 'training_admin',
  INSTRUCTOR: 'instructor',
  COMPANY: 'company',
  STUDENT: 'student'
};

// Role display names
export const RoleDisplayNames = {
  admin: 'Administrator',
  training_admin: 'Training Admin',
  instructor: 'Instructor',
  company: 'Company',
  student: 'Student'
};

// Check if user can manage users
export function canManageUsers(role) {
  return [UserRoles.ADMIN, UserRoles.TRAINING_ADMIN, UserRoles.INSTRUCTOR].includes(role);
}

// Check if user can issue certificates
export function canIssueCertificates(role) {
  return [UserRoles.ADMIN, UserRoles.TRAINING_ADMIN].includes(role);
}

// Check if user can manage courses
export function canManageCourses(role) {
  return role === UserRoles.ADMIN;
}

// Check if user can manage classes
export function canManageClasses(role) {
  return [UserRoles.ADMIN, UserRoles.TRAINING_ADMIN, UserRoles.INSTRUCTOR].includes(role);
}

// Country options
export const CountryOptions = [
  { value: 'Cyprus', label: 'Cyprus' },
  { value: 'Greece', label: 'Greece' },
  { value: 'United Kingdom', label: 'United Kingdom' }
];

// Company category options
export const CompanyCategoryOptions = [
  { value: 'Hotel', label: 'Hotel' },
  { value: 'Bank', label: 'Bank' },
  { value: 'Gym', label: 'Gym' },
  { value: 'Bakery', label: 'Bakery' },
  { value: 'Kindergarten', label: 'Kindergarten' }
];

export async function openAttachment(url) {
  const win = window.open('', '_blank');
  try {
    const res = await axios.get(url, { responseType: 'blob' });
    const blobUrl = URL.createObjectURL(res.data);
    if (win) win.location.href = blobUrl; else window.location.href = blobUrl;
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  } catch (e) {
    if (win) win.close();
    throw e;
  }
}
